import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagUyu = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_148_8549)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9996 8.8687H23.5862C23.2854 7.75242 22.828 6.7005 22.2384 5.73825H11.9996V8.8687Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.53009 21.3898H19.4698C20.5649 20.5176 21.5041 19.4581 22.2386 18.2594H1.76123C2.49581 19.4581 3.435 20.5176 4.53009 21.3898Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0001 -0.000854492C12.0001 1.04263 12.0001 2.60783 12.0001 2.60783H19.47C17.4201 0.975271 14.8243 -0.000854492 12.0001 -0.000854492Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9996 8.8687H23.5862C23.2854 7.75242 22.828 6.7005 22.2384 5.73825H11.9996V8.8687Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.00012207 12.0001C0.00012207 13.0833 0.144497 14.1324 0.413513 15.1306H23.5868C23.8557 14.1324 24.0001 13.0833 24.0001 12.0001H0.00012207Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4352 7.0232L8.96965 7.71259L9.75007 9.13197L8.15867 8.82756L7.95701 10.4351L6.8486 9.25276L5.7401 10.4351L5.53849 8.82756L3.94709 9.13187L4.72746 7.71255L3.26196 7.0232L4.72751 6.3339L3.94709 4.91453L5.53845 5.21894L5.74015 3.61136L6.8486 4.79373L7.95706 3.61136L8.15867 5.21894L9.75012 4.91453L8.9697 6.33395L10.4352 7.0232Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_148_8549",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgFlagUyu;
